import { BackgroundMedia } from '@/features/auth/BackgroundMedia';
import { LanguageSwitcher } from '@/features/language-switcher';
import { useProfileQuery } from '@/models/user';
import { Outlet, Navigate } from 'react-router';
import { NAVIGATION_PATH } from '../constants';

export const AuthLayout = () => {
  const { data } = useProfileQuery();

  if (data) {
    return <Navigate to={NAVIGATION_PATH[data.role]} replace />;
  }

  return (
    <>
      <BackgroundMedia />
      <div className="flex flex-col h-full w-full relative md:p-8">
        <div className="hidden sm:flex basis-16 items-center justify-end">
          <LanguageSwitcher dark />
        </div>
        <Outlet />
      </div>
    </>
  );
};
